"use strict";

exports.__esModule = true;
exports["default"] = CircularIndeterminate;

var _react = _interopRequireDefault(require("react"));

var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function CircularIndeterminate() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    size: 50
  }));
}

module.exports = exports.default;